import {colors} from "../../../../../../enums/colors";
import React from "react";
import {
    DownloadIcon,
    IconMaterialType,
    IconCube3d, PersonChip
} from "../../../../../../components/buttons/IconButtons";
import {getMaterialControlItemTypeTab} from "../../../Model/Model";
import CustomChip from "../../../../../../components/CustomChip";
import {
    DATE_TIME_FORMAT_NAME_MODEL,
    downloadActionFile, getDateFormat, sanitizeString
} from "../../../../../../Apis/functions";
import CustomFileCard from "../../../../../../components/CustomFileCard";
import ButtonAction from "../../../../../../components/buttons/ButtonAction";
import {getUnitTransByName} from "../../../../Dining/Ingredients/Model/Models";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const EntryAndExitFormDiscrepancyCard = ({
    t,
    item,
    file,
    dispatched = false
}) => {
    // A material captured with a quantity is read with it, and the one that is
    // only described is read with the direction it takes at the plant
    const quantity = item?.quantity != null
        ? `${item.quantity} ${t(getUnitTransByName(item?.measurementUnitName))}`
        : null;
    const typeTab = getMaterialControlItemTypeTab(item?.type);
    // The review travels with the evidence the gate uploaded for the material,
    // and the note of the validation is the one the guard wrote for it
    const review = item?.itemEvidence || null;
    const note = sanitizeString(item?.validationNote) || sanitizeString(review?.note);
    // A material the gate did not validate carries no review, so the material is
    // read on its own instead of with an empty block below it. What the gate
    // wrote is a draft until the dispatch is registered, so a folio that was
    // reported without dispatching its materials reads none of it either.
    const hasReview = dispatched && Boolean(review || note);

    return (
        <div className='border-radius-8px border-full-shades-100 background-shades-50 p-3'>
            <div className={"d-flex align-items-center justify-content-between"}>
                <div className={"d-flex align-items-center"}>
                    <div className={"mr-2"}><IconCube3d/></div>
                    <p className={"ibl-font-w-600 fs-14px"}>{item?.name}</p>
                </div>

                {(quantity || typeTab) &&
                    <div>
                        <p className={"fs-12px text-right"}>{t(quantity ? "quantity" : "type")}</p>
                        <CustomChip
                            background={colors.secondary100}
                            fontColor={colors.secondary700}
                            borderColor={colors.secondary150}
                            legend={quantity || t(typeTab.translation)}
                            icon={<IconMaterialType width={14} height={14} />}
                            className='icon-color-secondary-700'
                        />
                    </div>
                }
            </div>

            {hasReview &&
            <>
            <div className={"border-bottom-shades-300 my-3"}/>

            <div className={"border-radius-8px border-full-shades-200 background-shades-100"}>
                <div className={"d-flex p-3"}>
                    <div className={"mr-2"}>
                        <PersonChip className={"icon-color-shades-400"}/>
                    </div>
                    <div className={"flex-grow-1 minw-0"}>
                        <div className={"mb-2"}>
                            <p className={"ibl-font-w-600 fs-14px"}>{review?.uploadedBy}</p>
                            <p className={"fs-14px"}>
                                {getDateFormat(review?.createdAt, true, DATE_TIME_FORMAT_NAME_MODEL.shortMonth)}
                            </p>
                        </div>
                        {note &&
                            <div className={"border-radius-8px background-general-00 p-2 w-100 mb-2"}>
                                <p className={"fs-14px"}>{note}</p>
                            </div>
                        }

                        {file &&
                            <CustomFileCard
                                downloadAtEnd
                                showIcon={true}
                                Icon={file.Icon}
                                title={file.userFileName}
                                subtitle={file.size}
                                fileValue={file.filePath}
                                showBtnDownload={false}
                                classes='card-shades-100-50 border-radius-8px'
                                extraActions={
                                    <div className={"d-flex gap-2"}>
                                        <ButtonAction
                                            key={`btn_mdc_download_${item?.id}`}
                                            Icon={DownloadIcon}
                                            id={`btn_mdc_download_${item?.id}`}
                                            className={'btn-outlined-secondary-600-25 btn-icon-svg-chip-button w-40px h-40px minw-40px p-0'}
                                            iconClass={'mr-0'}
                                            onClick={() => {
                                                downloadActionFile(file?.filePath);
                                            }}
                                        />
                                    </div>
                                }
                                classContent="pb-3"
                                required={true}
                            />
                        }
                    </div>
                </div>
            </div>
            </>
            }
        </div>
    );
};


export default EntryAndExitFormDiscrepancyCard
